<template>
  <a-tree-select
    v-bind="attrs"
    :class="[bem.b(), bem.is(isGray ? 'gray-tree-select' : '')]"
    :tree-line="treeLine && { showLeafIcon }"
    :popup-class-name="`${bem.b()}-dropdown ${popupClassName}`"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-tree-select>
</template>

<script setup lang="ts">
// import { Tree } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import { treeSelectProps } from './tree-select'

defineOptions({ name: 'LlTreeSelect' })

const attrs = useAttrs()

defineProps(treeSelectProps)

const bem = createNamespace('tree-select')
</script>

<style scoped></style>
